import { clientConfig } from '@/config/client';
import { ProfileManager } from '@/shared/lib/profileManager';

interface Props {
    profileManager: ProfileManager;
}

const { productServiceName } = clientConfig;

export const getPuidAndFrom = ({ profileManager }: Props) => {
    const puid = profileManager.userProfile?.puid;

    return {
        puid: puid === null || puid === undefined ? '' : String(puid),
        from: productServiceName,
    };
};
